import Axios from "../globals/axios/axios.index";

export const contactUsAPIService = {
    submitContactUsAPIForm: (
        Response: any,
    ) => {
        return Axios.post(`/create-lead/`, Response);
    },
};
